import React from 'react';
import * as PropTypes from 'prop-types';
import ChaMeta11 from 'dc/ChaMeta11';
import Spa16 from 'dc/Spa16';
import { Wrapper } from './elements';
import { ICON } from 'resources/constants';

type Props = {
  className?: string;
  average_in_team_text: string;
  average_in_unit_text: string;
  sectionTerm: string;
  you_text: string;
  avatarImage?: string;
  isLoadingAvatar?: boolean;
  profilePercentage?: number;
  profileIndicator?: number | string;
  teamPercentage?: number;
  teamIndicator?: number | string;
  sectionPercentage?: number;
  sectionIndicator?: number | string;
  indicatorColor?: string;
  readonly indicatorIcon?: string;
};

function ChStPrt4(props: Props): React.ReactElement {
  return (
    <Wrapper className={props.className}>
      <Spa16 />
      <ChaMeta11
        avatarImage={props.avatarImage}
        isLoadingAvatar={props.isLoadingAvatar}
        labelText={props.you_text}
        percent={props.profilePercentage}
        type={'user'}
        value={props.profileIndicator}
        icon={props.indicatorIcon}
        indicatorColor={props.indicatorColor}
      />
      <ChaMeta11
        groupIcon={ICON.team}
        icon={props.indicatorIcon}
        indicatorColor={props.indicatorColor}
        labelText={props.average_in_team_text}
        percent={props.teamPercentage}
        value={props.teamIndicator}
      />
      {props.sectionTerm?.length > 0 && (
        <ChaMeta11
          groupIcon={ICON.locationCity}
          icon={props.indicatorIcon}
          indicatorColor={props.indicatorColor}
          labelText={props.average_in_unit_text}
          percent={props.sectionPercentage}
          value={props.sectionIndicator}
        />
      )}
    </Wrapper>
  );
}

ChStPrt4.propTypes = {
  className: PropTypes.string,
  average_in_team_text: PropTypes.string,
  average_in_unit_text: PropTypes.string,
  sectionTerm: PropTypes.string,
  you_text: PropTypes.string,
  avatarImage: PropTypes.string,
  isLoadingAvatar: PropTypes.bool,
  profilePercentage: PropTypes.number,
  profileIndicator: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  teamPercentage: PropTypes.number,
  teamIndicator: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  sectionPercentage: PropTypes.number,
  sectionIndicator: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  indicatorColor: PropTypes.string,
};

export default ChStPrt4;
